module.exports = __webpack_public_path__ + "static/media/USDT.eac1f7bb15967c89034b440b095ad74c.svg";